import { tokenInfoAtom } from '@/atoms/tokenInfo';
import { ActionPanel } from '@/components/CA/ActionPanel';
import { Analysis } from '@/components/CA/Analysis';
import { Breakdown } from '@/components/CA/Breakdown';
import { Overview } from '@/components/CA/Overview';
import { PanelFooter } from '@/components/CA/PanelFooter';
import { TopTenHolders } from '@/components/CA/TopTenHolders';
import { useAtomValue } from 'jotai';
import { motion } from 'motion/react';
import TGMetrics from '../TGMetrics';
import { HelioFrame } from './HelioFrame';
import { LiquidityGraph } from './LiquidityGraph';
import { RepoAnalyzer } from './RepoAnalyzer';
import { TokenMap } from './TokenMap';

export const InfoPanel = () => {
  const tokenInfoResult = useAtomValue(tokenInfoAtom);
  if (!tokenInfoResult) return null;

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: -30 }}
        transition={{ duration: 1.5 }}
        className="space-y-6 bg-black/50 backdrop-blur-sm rounded-xl p-6 w-full"
      >
        <ActionPanel />
        <div className="flex flex-wrap gap-6">
          <div className="w-full sm:flex-1 sm:min-w-[426px]">
            <Overview />
          </div>
          <div className="w-full sm:flex-1 sm:min-w-[192px]">
            <Breakdown />
          </div>
          <div className="w-full sm:flex-1 sm:min-w-[384px]">
            <Analysis />
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-6">
            <LiquidityGraph />
          </div>
          <div className="col-span-12 md:col-span-6">
            <TopTenHolders />
          </div>
        </div>

        <TGMetrics />

        <TokenMap />

        <RepoAnalyzer />

        <HelioFrame />

        <PanelFooter />
      </motion.div>
    </>
  );
};
